module.exports = __webpack_public_path__ + "static/media/alerts-icon-edit.d93beaa9.svg";